import {cardImages} from '../../assets/ImageIndex'

interface ElementType {
  type: string ;
  content: string | string[] | ElementType[]; // Ajuste para suportar listas ou elementos aninhados
  getStyles?: (breakpoints: {
    isDesktopOrLaptop?: boolean;
    isMiniNotebook?: boolean;
    isMobileBig?: boolean;
    isMobileMedium?: boolean;
    isMobileMini?: boolean;
  }) => React.CSSProperties;
}

const titleA = ({
  isDesktopOrLaptop,
  isMiniNotebook,
  isMobileBig,
  isMobileMedium,
  isMobileMini
  }: {
  isDesktopOrLaptop?: boolean;
  isMiniNotebook?: boolean;
  isMobileBig?: boolean;
  isMobileMedium?: boolean;
  isMobileMini?: boolean;
  }) => ({
  textAlign: 'center',
  flexDirection: 'column',
  color: '#333',
  fontWeight: 'bold', 
  fontSize: isMobileMini ? '15px': isMobileMedium ? '17px': isMobileBig ? '18px': isMiniNotebook ? '20px' : '25px',
});

const brA = (isDesktopOrLaptop: boolean) => ({
  height: '8px',
});
const brB = (isDesktopOrLaptop: boolean) => ({
  height: '5px',
});
const brC = (isDesktopOrLaptop: boolean) => ({
  height: '3px',
});
const brD = (isDesktopOrLaptop: boolean) => ({
  height: '2px',
});



const textA = ({
  isDesktopOrLaptop,
  isMiniNotebook,
  isMobileBig,
  isMobileMedium,
  isMobileMini
  }: {
  isDesktopOrLaptop?: boolean;
  isMiniNotebook?: boolean;
  isMobileBig?: boolean;
  isMobileMedium?: boolean;
  isMobileMini?: boolean;
  }) => ({
  color: '#333',
  fontSize: isMobileMini ? '13px': isMobileMedium ? '14px': isMobileBig ? '16px': isMiniNotebook ? '18px' : '18px',
  marginRight: isMobileMini ? '4px': isMobileMedium ? '4px': isMobileBig ? '10px': isMiniNotebook ? '20x' : '35px',
  marginLeft: isMobileMini ? '4px': isMobileMedium ? '4px': isMobileBig ? '10px': isMiniNotebook ? '20x' : '35px',
  width: isMobileMini ? '310px': isMobileMedium ? '460px': isMobileBig ? '570px': isMiniNotebook ? '700x' : '900px',

  textAlign: 'justify',
});

const textB = ({
  isDesktopOrLaptop,
  isMiniNotebook,
  isMobileBig,
  isMobileMedium,
  isMobileMini
  }: {
  isDesktopOrLaptop?: boolean;
  isMiniNotebook?: boolean;
  isMobileBig?: boolean;
  isMobileMedium?: boolean;
  isMobileMini?: boolean;
  }) => ({
  color: '#333',
  fontSize: isMobileMini ? '13px': isMobileMedium ? '14px': isMobileBig ? '16px': isMiniNotebook ? '18px' : '18px',
  marginRight: isMobileMini ? '4px': isMobileMedium ? '4px': isMobileBig ? '10px': isMiniNotebook ? '20x' : '35px',
  marginLeft: isMobileMini ? '4px': isMobileMedium ? '4px': isMobileBig ? '10px': isMiniNotebook ? '20x' : '35px',
  //width: isMobileMini ? '260px': isMobileMedium ? '260px': isMobileBig ? '450px': isMiniNotebook ? '700x' : '900px',

  textAlign: 'justify',
});

const divA = ({
  isMiniNotebook,
  isMobileBig,
  isMobileMedium,
  isMobileMini
  }: {
  isMiniNotebook?: boolean;
  isMobileBig?: boolean;
  isMobileMedium?: boolean;
  isMobileMini?: boolean;
  }) => ({
  display:'flex',
  'flex-direction': isMobileMini ? 'column': isMobileMedium ? 'column': isMobileBig ? 'column': isMiniNotebook ? 'row' : 'row', /// '16px', //'column',
  padding: isMobileMini ? '4px': isMobileMedium ? '6px': isMobileBig ? '8px': isMiniNotebook ? '12px' : '16px', /// '16px',
  textAlign: 'justify',
});

const divB = ({
  isMiniNotebook,
  isMobileBig,
  isMobileMedium,
  isMobileMini
  }: {
  isMiniNotebook?: boolean;
  isMobileBig?: boolean;
  isMobileMedium?: boolean;
  isMobileMini?: boolean;
  }) => ({
  display:'flex',
  'flex-direction': 'column', /// '16px', //'column',
  padding: isMobileMini ? '4px': isMobileMedium ? '6px': isMobileBig ? '8px': isMiniNotebook ? '12px' : '16px', /// '16px',
  textAlign: 'justify',
});

const listA = ({
  isMiniNotebook,
  isMobileBig,
  isMobileMedium,
  isMobileMini
  }: {
  isMiniNotebook?: boolean;
  isMobileBig?: boolean;
  isMobileMedium?: boolean;
  isMobileMini?: boolean;
  }) => ({
    color: '#333',
    fontSize: isMobileMini ? '13px': isMobileMedium ? '14px': isMobileBig ? '16px': isMiniNotebook ? '18px' : '18px',
    gap: isMobileMini ? '8px': isMobileMedium ? '10px': isMobileBig ? '15px': isMiniNotebook ? '18px' : '18px',
    textAlign: 'justify',
    width: isMobileMini ? '290px': isMobileMedium ? '440px': isMobileBig ? '550px': isMiniNotebook ? '680x' : '880px',
})

const imageA = ({
  isMiniNotebook,
  isMobileBig,
  isMobileMedium,
  isMobileMini,
  isDesktopOrLaptop
}: {
  isMiniNotebook?: boolean;
  isMobileBig?: boolean;
  isMobileMedium?: boolean;
  isMobileMini?: boolean;
  isDesktopOrLaptop?: boolean;
  }) => ({
    width: isMobileMini ? '290px': isMobileMedium ? '420px': isMobileBig ? '450px': isMiniNotebook ? '200px' : isDesktopOrLaptop? '450px' : '500px',
    alignItems: 'center',
    textAlign: 'center',
    margin: '0 auto',
    borderRadius: '10px',
})

export const card_18_01_25 = {

  date: '18-01-2025',
  routeCard: '/nutricao/vitaminas-essenciais/18-01-2025',
  description: 'Vitaminas Essenciais: O Segredo para uma Dieta Balanceada e Mais Energia!',
  month: 'Janeiro',
  shortTitle: 'Vitaminas Essenciais: O Segredo para uma Dieta Balanceada.',
  elements: [
    {
      type: 'title',
      content: 'Vitaminas Essenciais: O Segredo para uma Dieta Balanceada e Mais Energia!',
      getStyles: titleA,
    },
    {
      type: 'br',
      content: '',
      getStyles: brA,
    },
    {
      type: 'div',
      content: [
        {
          type: 'image',
          content: cardImages.fruitsBanner_18_01_25,
          getStyles: imageA,
        },
        {
          type: 'text',
          content: 
          `
          <p style="text-indent: 20px;">
          A vida agitada e os hábitos alimentares nem sempre tão saudáveis são um desafio em 
          garantir a ingestão correta de vitaminas, 
          esses nutrientes valiosos são fundamentaais para manter o equilíbrio do organismo. 
          As vitaminas desempenham um papel crucial na obtenção de uma vida saudável, 
          fortalecendo o sistema imunológico, até a melhora do metabolismo e do bem-estar geral. 
          De que forma podemos garantir que o consumo está em quantidades adequadas desses nutrientes? 
          A resposta está em uma dieta balanceada e bem planejada.
          </p>
          <br></br>
          `,
          getStyles: textB,
        },
      ],
      getStyles: divB,
    },
    
    {
      type: 'div',
      content: [
        {
          type: 'title',
          content: 'Natural X Manipulada',
          getStyles: titleA,
        },
        {
          type: 'text',
         content: 
          `
          <p style="text-indent: 20px;">
          Existe um debate grande sobre qual a melhor forma de se obter a quantidade necessaária de vitaminas, seja de forma natural,
           através da ingestão de alimentos ou pela suplementação através da forma manipulada. Ainda não existe um concenso, entretanto uma coisa é certa.
           O organismo não produz nenhum destes compostos sendo necessária a via oral. Uma vantagem da ingestão através dos alimentos é que sua abosrção se dá de forma mais eficiente.
           Ja na forma de suplementação é mais comum uma dose diaria constante dos nutrientes.
          </p>
          `,
        getStyles: textB,
    },
    {
      type: 'image',
      content: cardImages.VitaminCapsules_18_01_25,
      getStyles: imageA,
    },
      ],
      getStyles: divB,
    },
    {
      type: 'div',
      content: [
        {
          type: 'br',
          content: '',
          getStyles: brC,
        },
        {
          type: 'title',
          content: 'O Papel das Vitaminas na Saúde',
          getStyles: titleA, 
        },
        {
          type: 'br',
          content: '',
          getStyles: brC,
        },
        {
          type: 'text',
          content: `As vitaminas são componentes orgânicos essenciais para algumas funções do corpo. 
          A grande maioria das vitaminas não são produzidas pelo organismo, 
          diferente da vitamina D que é produzida e é afetada pela quantidade de luz solar que recebemos diariamente. Há 13 vitaminas essenciais, divididas em dois grupos: `,
          getStyles: textB,
        },
        {
          type: 'br',
          content: '',
          getStyles: brD,
        },
        {
          type: 'list',
          content: [
            'As lipossolúveis (A, D, E e K), que são armazenadas no tecido adiposo.',
           'As hidrossolúveis (complexo B e C), que necessitam ser ingeridas com maior frequência uma vez que não são armazenadas no organismo.'
          ],
          getStyles: listA,          
        },
        {
          type: 'br',
          content: '',
          getStyles: brD,
        },
        {
          type: 'image',
          content: cardImages.Carrots_18_01_25,
          getStyles: imageA,
        },
        {
          type: 'text',
          content: ' De um modo geral a permanencia de tais nutrientes varia de pessoa para pessoa e testes modernos conseguem verificar com eficácia se determinada vitamina esta deficiente no corpo.',
          getStyles: textB,
        },
        {
          type: 'br',
          content: '',
          getStyles: brC,
        },
      ],
      getStyles: divB,
    },
    {
      type: 'div',
      content: [
        {
          type: 'title',
          content: 'Principais Fontes de Vitaminas em Alimentos.',
          getStyles: titleA, 
        },
        {
          type: 'image',
          content: cardImages.pumpkinNatural_18_01_25,
          getStyles: imageA,
        },
        {
          type: 'text',
          content: 
          `<br></br>
          <p style="text-indent: 20px;"> O segredo para receber uma dose generosa e suficiente de vitaminas é criar um habito saudável, de preferencia dando prioridade a alimentos frescos de origem vegetal
           e em alguns casos de origem animal. Na lista a seguir um breve resumo das principais fontes de vitaminas nos alimentos: </p>
          <br></br>
          `,
          getStyles: textB,
        },
        {
          type: 'list',
          content: [
            'Vitamina A: cenoura, abóbora, batata-doce e espinafre.',
            'Vitamina C: tomate, laranja, acerola, kiwi e morango.',
            'Vitamina D: salmão, atum, ovos e exposição ao sol.',
            'Vitamina E: amêndoas, sementes de girassol e azeite de oliva.',
            'Vitamina K: brócolis, couve e espinafre.',
            'Vitaminas do complexo B: carne, ovos, laticínios, leguminosas e cereais integrais.'
          ],
          getStyles: listA,          
        }
      ],
      getStyles: divB,
    },
    {
      type: 'br',
      content: '',
      getStyles: brA,
    },
    {
      type: 'div',
      content: [
        {
          type: 'title',
          content: 'Efeitos Adversos de Uma Dieta Pobre em Vitaminas',
          getStyles: titleA, 
        },
        {
          type: 'text',
          content: 
          `<br></br>
          <p style="text-indent: 20px;"> 
          A deficiência de vitaminas pode trazer consequências graves para a saúde. A falta de vitamina D, por exemplo, pode levar a problemas ósseos, como osteoporose. A carência de vitamina C pode resultar em baixa imunidade e dificuldades na cicatrização, enquanto a deficiência de vitaminas do complexo B pode causar fadiga, problemas neurológicos e anemia.
          Por isso, é importante ficar atento aos sinais que o corpo dá e, caso necessário, buscar orientação médica para avaliar a necessidade de suplementação. No entanto, a suplementação só deve ser feita sob recomendação profissional, pois o excesso de certas vitaminas pode ser prejudicial.
          Manter uma dieta balanceada e rica em vitaminas é um dos pilares para ter mais saúde, disposição e qualidade de vida. 
          <br></br>
          `,
          getStyles: textB,
        },
      ],
      getStyles: divB,
    },
  ] as ElementType[],
  tags: ['nutrição', 'vitaminas', 'alimentação', 'suplementos', 'natural'],
  author: 'John Doe',
}

